import React, { useEffect, useState } from 'react'
import { useSelector,useDispatch } from 'react-redux';
import moment from 'moment';
import TabData from './Components/TabData';
import "./style.css";
import { useLocation, useNavigate,useSearchParams,useParams } from 'react-router-dom';
import { isString } from '../../helper';
import { MEDIAPATH } from '../../Redux/Actions/config';
import PDFPopup from './Components/PdfPopup';
import back from "../../Assets/images/back.svg"
import banner1 from "../../Assets/images/listing-1.png"
import banner2 from "../../Assets/images/listing-4.png"
import banner3 from "../../Assets/images/listing-3.png"
import Slider from 'react-slick';
import Base from '../../Components/Layout/Base';
import { Document, Page } from 'react-pdf';
import { fetchNormalSubmission, getProfile, introVideoDetails } from '../../Redux/Actions/ProfileSteps';
const ProtfolioDetails = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const {college} = useParams();
  const profileData = useSelector(s => s.ProfileSteps.profileData);
  const profile = profileData;
  const [data, setData] = useState(profile || "")
  const localData = location.state?.data;
  const companyBanner = location.state?.companyBanner
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [kidId,setKidId] = useState( props?.kidId)
  // Login
  const [pdf, setPdf] = useState('');
    const kids = useSelector(state => state.dashboard.kids);
  const resumeData = useSelector(s => s.ProfileSteps.submissionData);
  const dispatch = useDispatch()
    useEffect(() => {
      if (!isAuthenticated) {
        navigate('/home');
      }
    }, [isAuthenticated]);
  useEffect(()=>{
    kids && kids[0]?.id && dispatch(getProfile(kids[0]?.id))
    kids && kids[0]?.id && dispatch(fetchNormalSubmission({ kid_id: kids[0]?.id,"activity_id":1172 }))
    kids && kids[0]?.id && dispatch(introVideoDetails({ kid_id: kids[0]?.id }))
  },[kids])
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])
  useEffect(() => {
    setData(profile)
  }, [profile])
useEffect(() => {
  if (id && id.length === 4) {
    setKidId(id);
  } else if (!id && localData?.kid_id) {
    setKidId(localData.kid_id);
  }
}, [id, localData?.kid_id]);


  const [showPDFPopup, setShowPDFPopup] = useState(false);
  
  const handleImageClick = (pdf) => {
    setPdf(pdf)
    setShowPDFPopup(true);
  };
  
  const handleClosePDF = () => {
    setShowPDFPopup(false);
  };
  const settings = {
    dots: false,
    autoplaySpeed: 3000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    infinite: true,
    autoplay:true,
  };
  const profileSettings = {
    dots: true,
    autoplaySpeed: 3000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    infinite: true,
    autoplay:true,

  }
  return (
      <>
      <Base>
        {companyBanner ? <div className="summary-banner bg-light">
                <div className='container'>
                  <div className='row'>
                    <div className='col-6 col-md-7 col-xl-6'>
                      <h1 className='quicksand pt-md-5'>
                        {companyBanner?.collegeName}
                        <span className='d-block'>Student Digital Portfolio</span>
                      </h1>
                    </div>
                    <div className='col-6 col-md-5 col-xl-6 d-flex align-items-center justify-content-center'>
                      <img src={`${companyBanner?.collegeLogo}`} className='company-img mw-auto' />
                    </div>
                  </div>
                </div>
              </div>
        :<>
        <section className='profile-banner no-data-banner'>
          {(profile?.post_graduation_college_logo || profile?.post_graduation_college) ?
          <div className='d-flex'>
            {profile?.post_graduation_college_logo && <img className='logo-image' src={`${profile?.post_graduation_college_logo}`} />}
            <p className='fs-3 ms-4 mt-3'>{profile?.post_graduation_college}</p>
            {/* <img src='./images/banner-profile4.png' /> */}
          </div> :
          
          <div className='container'>
                  <div className='row w-100 col-6 col-md-5 col-xl-6 d-flex align-items-center justify-content-center'>
                      *Your College name & logo will come here*
                    <div className='w-100 col-6 col-md-5 col-xl-6 d-flex align-items-center justify-content-center'>
                      {/* <img src={`${companyBanner?.collegeLogo}`} className='company-img mw-auto' /> */}
                    </div>
                  </div>
                </div>}
        </section>
        </>} 
        <section className='main-profile-content pb-5'>
          <div className='container-fluid'>
            <Slider {...profileSettings} className='profile-slider mt-3'>
              <div>
                  <img className='w-100 d-none d-lg-block' src='./images/banner-profile4.svg' />
                  <img className='w-100 d-block d-lg-none' src='./images/mob-banner-profile1.svg' />
              </div>
              <div>
                  <img className='w-100 d-none d-lg-block' src='./images/banner-profile2.svg' />
                  <img className='w-100 d-block d-lg-none' src='./images/mob-banner-profile2.svg' />

              </div>
              <div>
                  <img className='w-100 d-none d-lg-block' src='./images/banner-profile3.svg' />
                  <img className='w-100 d-block d-lg-none' src='./images/mob-banner-profile3.svg' />

              </div>
              </Slider>
            <div className='row'>
              <div className='col-xl-3 position-relative'>
                <div className='profile-left-area'>
                  <div className='d-flex align-items-center mb-2 mb-lg-0 position-relative pt-5 pt-lg-0'>
                    {/* <button 
                      onClick={() => college ? navigate(`/${college}`) : navigate("/")} 
                      className='border-0 bg-transparent position-absolute top-0 left-0 ps-0'
                    >
                      <img src={back} alt="back" />
                    </button> */}
                     {profile?.user_image_url ? 
                    <div className={` profile-user-img avatar-bg `}>
                     <img 
                        src={profile?.user_image_url } 
                        alt="profile"
                      /> </div>: <>
                      <div className='no-data-profile'>
                        <img 
                          src={`images/default-img.png`} 
                          alt="profile"
                        />
                        <p className='d-none d-lg-block'>Your image will come here</p>
                      </div>
                      </>}
                    
                     <div className='d-flex align-items-center d-lg-none ps-3'>
                      <h3 className='profile-user-name mb-0'>{data?.user_name} {data?.profileVerified && <img src={`${MEDIAPATH}/images/verify-tag.png`} />}</h3>
                      <div className='acc-edit-icon ms-1' onClick={() => navigate('/profile', {state: {step: 1}})}><img src='./svg/edit-blue.svg' /></div>
                    </div>
                     <div className='qr-code d-block d-lg-none'>
                        <img src='/portfolio/images/qr.png' alt="QR code image" className='w-50' />
                      </div>
                  </div>
                  <div type="button" className='acc-edit-icon d-none d-lg-flex justify-content-center' onClick={() => navigate('/profile', {state: {step: 1}})}><img src='./svg/edit-blue.svg' />Edit</div>
                 {/* <div className='profile-user-info no-data-bg '> lens icon  */} 
                  <div className='profile-user-info '>
                      {/* <button className='default-btn shortlisted  py-2 mt-2 mb-3 mb-md-0 d-block d-lg-none'>Shortlisted candidate</button> */}
                    {/* <h3 className='profile-user-name inter justify-content-center'>{profile?.kid?.name} <img src={`${MEDIAPATH}/images/verify-tag.png`} /></h3> */}
                    <h3 className='profile-user-name d-none d-lg-flex justify-content-center mb-3'>{data?.user_name} {data?.profileVerified && <img src={`${MEDIAPATH}/images/verify-tag.png`} />}</h3>
                     {/* <button className='default-btn d-none d-lg-flex justify-content-center shortlisted my-4 mx-auto'>Shortlisted candidate</button> */}
                    <div className='d-flex align-items-start'>
                      {data?.email_id || data?.mobile_number || data?.gender || data?.current_city || data?.birth_date ?
                      <ul className='profile-info-list'>
                        <li><img src={`./images/email.svg`} /> <span>Email : </span> {data?.email_id || "N/A"}</li>
                        <li><img src={`./images/phone.svg`} /> <span>Contact No : </span>{data?.mobile_number || "N/A"}</li>
                        <li><img src={`./images/dob.svg`} /> <span>Gender : </span>{data?.gender || "N/A"}</li>
                        <li><img src={`./images/address.svg`} /> <span>Address : </span>{data?.current_city || "N/A"}</li>
                        <li><img src={`./images/dob.svg`} /> <span>DOB : </span>{data?.birth_date && moment(data?.birth_date).format("DD MMMM Y") || "N/A"}</li>
                      </ul> : <div className='no-data-profile '> <p>Your info will come here</p></div>}
                      {/* <button onClick={()=> navigate("/profile")}>edit</button> */}
                      <div className='profile-right-area pt-0 pe-0 pb-0 text-center d-flex d-lg-none flex-column '>
                        <div className='col-md-6 d-flex pe-lg-5 align-items-center'>
                      {resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl ?  
                    //  <img 
                    //     src={resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl} 
                    //     alt="resume" 
                    //     className='no-cv-img rounded' 
                    //     style={{ cursor: 'pointer' }} 
                    //     onClick={() => handleImageClick(resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl)} 
                    //   /> 
                    <Document 
                              file={resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl} 
                              className="resume-image"
                              onClick={() => handleImageClick(resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl)}
                            >
                              <Page
                                pageNumber={1}
                                renderTextLayer={false}
                                renderAnnotationLayer={false}
                              />
                            </Document>
                      :
                         <span className='no-cv-img rounded align-items-center justify-content-center' style={{ cursor: 'pointer',width: '100px' }}>No resume <br/> available</span> 
                        } 
                    </div>
                        <div>
                          {/* <button type='button' className={`site-btn ${profile?.isShortListed ? 'border-green-btn px-5' : 'border-btn px-4'} mt-3`} onClick={handleShortlistModal}>{profile?.isShortListed ? 'Shortlisted' : 'Shortlist Candidate'}</button> */}
                          {resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl && <button type='button' onClick={resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl} className={`default-btn bg-transparent blue-border-btn border-0 mt-2 p-0`}>Click to Enlarge</button>}
                        </div>
                        {/* <button onClick={()=> navigate("/profile")}>edit</button> */}
                    </div>
                    </div>
                    <div type="button" className='acc-edit-icon d-none d-lg-flex justify-content-center mb-5' onClick={() => navigate('/profile', {state: {step: 1}})}><img src='./svg/edit-blue.svg' />Edit</div>
                    {/* {profile?.csp_qr_url && */}
                      <div className='qr-code d-none d-lg-block'>
                        {/* <img src={profile?.csp_qr_url} alt="QR code image" /> */}
                        <img src={data?.cspQrUrl} alt="QR code image" />
                      </div>
                      {/* <div className='acc-edit-icon d-flex justify-content-center'><img src='./svg/edit-blue.svg' />Edit</div> */}
                    {/* // } */}
                  </div>
                  
                </div>
              </div>
              <div className='col-xl-7 mob-order-1'>
                <div className='profile-main-content-area'>
                  {/* {VideoBox(pinned?.data)} */}
                  <div className='mt-md-5 my-1 my-md-3'>
                    <TabData kidId={kidId} data={data} />
                  </div>
                </div>
              </div>
              <div className='col-xl-2  d-none d-lg-block'>
                <div className='cv-bg h-100'>
                  <div className='profile-right-area text-center d-lg-flex flex-column'>
                    <div className='d-flex align-items-center'>
                        {resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl ?  
                        <div className='w-100'>
                            <h3 className='cv-txt'>Resume</h3>
                            {/* <img 
                              src={resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl} 
                              alt="resume" 
                              className='no-cv-img rounded w-100' 
                              style={{ cursor: 'pointer' }} 
                              onClick={() => handleImageClick(resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl)} 
                            /> */}
                           <Document 
                              file={resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl} 
                              className="resume-image"
                              onClick={() => handleImageClick(resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl)}
                            >
                              <Page
                                pageNumber={1}
                                renderTextLayer={false}
                                renderAnnotationLayer={false}
                              />
                            </Document>
                        </div>
                        :<div className='w-100'>
                        <h3 className='cv-txt'>Resume</h3>
                          <span className='no-cv-img rounded align-items-center justify-content-center' style={{ cursor: 'pointer' }}>No resume <br/> available</span> 
                        </div>
                          } 
                      </div>
                    <div>
                      {/* <button type='button' className={`site-btn ${profile?.isShortListed ? 'border-green-btn px-5' : 'border-btn px-4'} mt-3`} onClick={handleShortlistModal}>{profile?.isShortListed ? 'Shortlisted' : 'Shortlist Candidate'}</button> */}
                      {resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl && <button type='button' onClick={() => handleImageClick(resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl)} className={`default-btn px-0 bg-transparent blue-border-btn border-0`}>Click to Enlarge</button>}
                    </div>
                    
                          <button className='acc-edit-icon d-flex justify-content-center bg-transparent border-0' onClick={()=> navigate("/profile")}><img src='./svg/edit-blue.svg' />edit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <PDFPopup 
        isOpen={showPDFPopup}
        onClose={handleClosePDF}
        pdfUrl={pdf}
        title={"Document Viewer"}
      />
        </section>
        </Base>
      </>
  )
}

export default ProtfolioDetails;